import { useNavigate } from 'react-router-dom';
import { formatStageLabel, formatCurrency } from '../../utils/formatters';
import SLABadge from './SLABadge';
import Badge from '../shared/UI/Badge';

export default function DealCard({ deal, slaInfo, actionLabel }) {
  const navigate = useNavigate();

  return (
    <div
      style={{
        border: '1px solid var(--color-border)',
        borderRadius: 'var(--radius)',
        padding: '14px 16px',
        background: 'var(--color-card)',
        marginBottom: 8,
        cursor: 'pointer',
        transition: 'box-shadow 0.15s',
      }}
      onClick={() => navigate(`/pipeline/${deal.id}`)}
      onMouseEnter={e => e.currentTarget.style.boxShadow = 'var(--shadow-sm)'}
      onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
        <p style={{ fontWeight: 600, fontSize: 14, color: 'var(--color-text)' }}>{deal.company_name}</p>
        <Badge text={deal.status || 'active'} />
      </div>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 8 }}>
        <p style={{ fontSize: 12, color: 'var(--color-text-secondary)' }}>{deal.sector || '—'}</p>
        <p style={{ fontSize: 12, color: 'var(--color-text-secondary)' }}>
          {formatCurrency(deal.requested_amount, deal.requested_currency)}
        </p>
        <p style={{ fontSize: 12, color: 'var(--color-text-secondary)' }}>{deal.company_country}</p>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{
          fontSize: 12,
          fontWeight: 500,
          padding: '2px 8px',
          borderRadius: 4,
          background: 'var(--color-border-light)',
          color: 'var(--color-text-secondary)',
        }}>
          {formatStageLabel(deal.current_stage)}
        </span>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {slaInfo && <SLABadge {...slaInfo} />}
          {actionLabel && (
            <span style={{
              fontSize: 12,
              fontWeight: 600,
              padding: '2px 10px',
              borderRadius: 4,
              background: 'var(--color-accent-light)',
              color: 'var(--color-accent-dark)',
            }}>
              {actionLabel}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
